import React from 'react';

const Loading: React.FC = React.memo(() => (
    <div
        style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)'
        }}
    >
        <i
            style={{ fontSize: 50, color: 'white' }}
            className="fa fa-spinner fa-spin"
        />
    </div>
));

export default Loading;
